import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/forgot-password/page.tsx");
